import { getFormKey, getForm } from './utils';
import FocusConnector from '../../accessibility/focus/connector';
import getAllFocusable from '../../accessibility/focus/get-all-focusables';

let focusableDiv = null;
let focusableElements = null;
let firstFocusableElement  = null;
let lastFocusableElement  = null;
let keyBoardAccessHandler  = null;

export const emailMeFormLoader = function (element) {
	if ($('.ENABLE_CACHE_LAZY_FORMS').length > 0) {
		return new Promise((resolve, reject) => {
			const formId = element.data('form_id');
			if (!formId) {
				reject(new Error('FormID is not defined'));
				return;
			}
			const postId = element.data('post_id') ? element.data('post_id') : et_pb_custom.page_id;
			try {
				const formKey = getFormKey(formId);
				if (!Object.prototype.hasOwnProperty.call(window.flNfFormsLoaded, formKey)) {
					window.flNfFormsLoaded[formKey] = {
						counter: 0,
						email_me_loaded: true,
					};
				} else if (!window.flNfFormsLoaded[formKey].email_me_loaded) {
					window.flNfFormsLoaded[formKey].counter += 1;
					window.flNfFormsLoaded[formKey].email_me_loaded = true;
				}

				getForm(formId, window.flNfFormsLoaded[formKey].counter, { post_id: postId })
					.then(response => resolve({
						element,
						response,
					}))
					.catch((error) => {
						error.element = element;
						reject(error);
					});
			} catch (error) {
				reject(error);
			}
		});
	}
	// Remove after AB#245834 in prod
	return new Promise((resolve, reject) => {
		const formId = element.data('form_id');
		const postId = element.data('post_id') ? element.data('post_id') : et_pb_custom.page_id;
		const formKey = getFormKey(formId);

		if (!Object.prototype.hasOwnProperty.call(window.flNfFormsLoaded, formKey)) {
			window.flNfFormsLoaded[formKey] = {
				counter: 0,
				email_me_loaded: true,
			};
		} else if (!window.flNfFormsLoaded[formKey].email_me_loaded) {
			window.flNfFormsLoaded[formKey].counter += 1;
			window.flNfFormsLoaded[formKey].email_me_loaded = true;
		}

		getForm(formId, window.flNfFormsLoaded[formKey].counter, { post_id: postId })
			.then(response => resolve({
				element,
				response,
			}))
			.catch((error) => {
				error.element = element;
				reject(error);
			});
	});
};

export const emailMeFormProcessor = function (formData) {
	const container = $('body');
	const formId = formData.element.data('form_id');
	const formContainer = $(`<div id="email_me_${formId}_container" />`).css('display', 'none');
	container.append(formContainer);
	// Add the form HTML where it needs to go.
	formContainer.html(formData.response.form);
	// Add template files to the page.
	const span = $('<span id="email_me_templates_container" />').css('display', 'none');
	container.append(span);
	span.html(formData.response.templates);
};

export const registerKeyBoardFocusHandler = () => {
	focusableDiv = document.querySelector('#email_attorney');
	focusableElements = getAllFocusable(focusableDiv);
	if (focusableElements.length) {
		firstFocusableElement = focusableElements[0];
		lastFocusableElement = focusableElements[focusableElements.length - 1];
		keyBoardAccessHandler = new FocusConnector(lastFocusableElement, firstFocusableElement);
		keyBoardAccessHandler.link();
	}
};

const unregisterKeyBoardFocusHandler = () => {
	keyBoardAccessHandler.unlink();
};

const getAttorneyName = () => {
	let currentJsonValues = null;
	let currentAttorneyName = null;
	document.querySelectorAll('script[type="application/ld+json"]').forEach((allJsonLdValues) => {
		currentJsonValues = JSON.parse(allJsonLdValues.textContent);
		if ((currentJsonValues['@type']) === 'ProfilePage') {
			currentAttorneyName = currentJsonValues.mainEntity.name;
		}
	});
	return currentAttorneyName;
};

export const maybeInitEmailMePopup = function() {
	const emailMeSelector = $('.et_pb_email_attorney');
	if (emailMeSelector.length === 0) {
		return;
	}
	let nfFormsLoaded = false;
	let currentFormId = null;

	let HTML = () => `
		  <div id="email_attorney" class="mfp-hide white-popup-block">
			<div id="email_attorney_content">
				<div class="nf-loading-spinner"></div>
			</div>
		  </div>
		`;

	if (document.getElementsByClassName('ENABLE_EMAIL_ME_CONTACT_FORM_POP_UP_FIX').length !== 0) {
		let attorneyName = null;
		attorneyName = getAttorneyName();
		HTML = () => `
		 <div role="dialog" id="email_attorney" aria-label="Email ${attorneyName}" aria-modal="true" class="mfp-hide white-popup-block">			 
			<h2 id="email_me_modal_heading">Contact Form</h2>			  		    
			<div id="email_attorney_content">
				<div class="nf-loading-spinner"></div>
			</div>
		 </div>
		`;
	}

	// Find container for HTML
	let container = null;
	if ($('body').length) {
		container = $('body');
	} else if ($('footer').length) {
		container = $('footer');
	} else if ($('#main-content').length) {
		container = $('#main-content');
	} else if ($('#page-container').length) {
		container = $('#page-container');
	}

	if (!container) {
		console.error('A container for an Email Me form is not found');
		return;
	}
	container.after(HTML);

	const showForm = () => {
		nfFormsLoaded = true;
		// Remove preloader
		$('#email_attorney_content div[class="nf-loading-spinner"]').remove();
		// Move the form to popup
		$(`#email_me_${currentFormId}_container`).contents().appendTo('#email_attorney_content');
		// Create a custom event to handle the form submit button behavior
		document.dispatchEvent(new CustomEvent('nf-form-loaded-in-popup'));
		document.removeEventListener('all-nf-forms-loaded', showForm);
	};

	const hideForm = (formId) => {
		if (document.getElementsByClassName('ENABLE_EMAIL_ME_CONTACT_FORM_POP_UP_FIX').length !== 0) {
			unregisterKeyBoardFocusHandler();
		}
		// Move the form from popup
		$('#email_attorney_content').contents().appendTo(`#email_me_${formId}_container`);
	};

	emailMeSelector.magnificPopup({
		type: 'inline',
		preloader: true,
		showCloseBtn: true,
		closeBtnInside: true,
		callbacks: {
			open () {
				currentFormId = $(this.currItem.el[0]).data('form_id');
				if (nfFormsLoaded) {
					showForm(currentFormId);
					if (document.getElementsByClassName('ENABLE_EMAIL_ME_CONTACT_FORM_POP_UP_FIX').length !== 0) {
						registerKeyBoardFocusHandler();
					}
				} else {
					document.addEventListener('all-nf-forms-loaded', showForm);
				}
			},
			close () {
				if (nfFormsLoaded) {
					hideForm(currentFormId);
				}
			},
		},
	});

	$(document).on('click', '.popup-modal-dismiss', (e) => {
		e.preventDefault();
		if (document.getElementsByClassName('ENABLE_EMAIL_ME_CONTACT_FORM_POP_UP_FIX').length !== 0) {
			unregisterKeyBoardFocusHandler();
		}
		$.magnificPopup.close();
	});

	document.addEventListener('all-nf-forms-loaded', () => {
		nfFormsLoaded = true;
	});
};



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/forms/contact-forms-lazy-load/email-me.js